/**
 * Ligonier-specific constants and default data
 */

import type { NavigationSection, Language, LegalLink, SocialLink, StoreContact, StoreLink } from '../types/footer'

export const defaultSections: Array<NavigationSection> = [
  {
    sys: {
      id: "2vDIfxALEiJWYjUdJtOKqU",
    },
    name: "Ministries",
    linksCollection: {
      items: [
        {
          name: "Tabletalk Magazine",
          type: "URL",
          url: "https://tabletalkmagazine.com/",
        },
        {
          name: "Renewing Your Mind",
          type: "URL",
          url: "https://renewingyourmind.org",
        },
        {
          name: "Ligonier Connect",
          type: "URL",
          url: "https://connect.ligonier.org",
        },
        {
          name: "Reformation Study Bible",
          type: "URL",
          url: "https://reformationstudybible.com",
        },
        {
          name: "Reformation Bible College",
          type: "URL",
          url: "https://reformationbiblecollege.org",
        },
        {
          name: "RefNet",
          type: "URL",
          url: "https://refnet.fm",
        },
      ],
    },
  },
  {
    sys: {
      id: "2JAY6iK3w2AaE5ySXA4AaO",
    },
    name: "Contact Us",
    linksCollection: {
      items: [
        {
          name: "Live Chat",
          type: "URL",
          url: "https://lc.chat/now/7423931/",
        },
        {
          name: "Email Us",
          type: "URL",
          url: "mailto:service@ligonier.org",
        },
        {
          name: "Call Toll Free: 800-435-4343",
          type: "URL",
          url: "tel:+1-800-435-4343",
        },
        {
          name: "421 Ligonier Ct. Sanford, FL 32771",
          type: "URL",
          url: "https://goo.gl/maps/Qw5HqYkZNMjyoCESA",
        },
        {
          name: "Chat Provider: LiveChat",
          type: "URL",
          url: "https://www.livechat.com/",
        },
      ],
    },
  },
]

export const defaultLanguages: Array<Language> = [
  { url: "https://ar.ligonier.org", label: "Arabic" },
  { url: "https://bn.ligonier.org", label: "Bengali" },
  { url: "https://zh.ligonier.org", label: "Chinese" },
  { url: "https://fa.ligonier.org", label: "Farsi" },
  { url: "https://fr.ligonier.org", label: "French" },
  { url: "https://de.ligonier.org", label: "German" },
  { url: "https://ha.ligonier.org", label: "Hausa" },
  { url: "https://hi.ligonier.org", label: "Hindi" },
  { url: "https://id.ligonier.org", label: "Indonesian" },
  { url: "https://ja.ligonier.org", label: "Japanese" },
  { url: "https://ko.ligonier.org", label: "Korean" },
  { url: "https://mr.ligonier.org", label: "Marathi" },
  { url: "https://pl.ligonier.org", label: "Polish" },
  { url: "https://pt.ligonier.org", label: "Portuguese" },
  { url: "https://ru.ligonier.org", label: "Russian" },
  { url: "https://es.ligonier.org", label: "Spanish" },
  { url: "https://sw.ligonier.org", label: "Swahili" },
  { url: "https://ta.ligonier.org", label: "Tamil" },
  { url: "https://te.ligonier.org", label: "Telugu" },
  { url: "https://tr.ligonier.org", label: "Turkish" },
  { url: "https://uk.ligonier.org", label: "Ukrainian" },
  { url: "https://ur.ligonier.org", label: "Urdu" },
  { url: "https://vi.ligonier.org", label: "Vietnamese" },
]

export const defaultLegalLinks: Array<LegalLink> = [
  {
    key: "footer-faq",
    label: "Faq",
    url: "https://www.ligonier.org/faqs",
  },
  {
    key: "footer-terms-of-use",
    label: "Terms of Use",
    url: "https://www.ligonier.org/terms",
  },
  {
    key: "footer-copyright-policy",
    label: "Copyright Policy",
    url: "https://www.ligonier.org/copyright-policy",
  },
  {
    key: "footer-privacy-policy",
    label: "Privacy Policy",
    url: "https://www.ligonier.org/privacy-policy",
  },
]

// Order matches the live site: Facebook, Instagram, X, TikTok, YouTube, LinkedIn.
export const defaultSocialLinks: Array<SocialLink> = [
  {
    icon: "facebook",
    key: "facebook",
    text: "Facebook",
    url: "https://www.facebook.com/Ligonier",
  },
  {
    icon: "instagram",
    key: "instagram",
    text: "Instagram",
    url: "https://instagram.com/ligonier",
  },
  {
    icon: "twitter",
    key: "twitter",
    text: "X",
    url: "https://twitter.com/ligonier",
  },
  {
    icon: "tiktok",
    key: "tiktok",
    text: "TikTok",
    url: "https://www.tiktok.com/@ligonier_ministries",
  },
  {
    icon: "youtube",
    key: "youtube",
    text: "YouTube",
    url: "https://www.youtube.com/LigonierMinistries",
  },
  {
    icon: "linkedin",
    key: "linkedin",
    text: "LinkedIn",
    url: "https://linkedin.com/company/ligonier-ministries/",
  },
]

export const storeLinks: Array<StoreLink> = [
  {
    key: "FAQ",
    url: "https://www.ligonier.org/faqs",
  },
]

export const storeContact: StoreContact = {
  chat: "https://lc.chat/now/7423931/",
  email: "mailto:service@ligonier.org",
  phone: "800-435-4343",
  phoneUrl: "tel:+1-800-435-4343",
}